module.exports = __webpack_public_path__ + "img/202112230156241985ys.e17edd6d.png";